import React, { useEffect } from "react";
import "./ForgotPasswordForm.css";

const ForgotPasswordConfirm = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="forgot-text">
        <h1 className="forgot-title">
          The password has been{" "}
          <span className="forgot-blue-text">successfully</span> reset.
        </h1>
        <h3 className="forgot-desc">
          <span className="forgot-gray-text">
            we will send you a link to change your password to your email
            address
          </span>
        </h3>
      </div>
    </>
  );
};

ForgotPasswordConfirm.displayName = "Confirmation";

export default ForgotPasswordConfirm;
